<!-- E2E-ISSUE-111: CMS "about" page (admin › settings › pages) takes precedence over the built-in copy. -->
<section *ngIf="cmsContent" class="cms-about">
  <div [dir]="isRtl ? 'rtl' : 'ltr'" class="container">
    @if (isUnified) {
    <h1 class="about-us-cms-title uc-display-sm uc-bold">{{ cmsTitle || ('footer.aboutUs' | translate) }}</h1>
    } @else {
    <h2 class="about-us-cms-title">{{ cmsTitle || ('footer.aboutUs' | translate) }}</h2>
    }
    <div class="about-us-cms-content" [innerHTML]="cmsContent"></div>
  </div>
</section>
<ng-container *ngIf="!cmsContent">
<section>
  <div class="d-lg-flex">
    <img alt="" class="d-none d-lg-block" loading="lazy" src="assets/imgs/about-us-bg1.svg"/>
    <div class="d-flex align-items-start">
      <img alt="" [ngClass]="{'en-mode': !isRtl}" loading="lazy" src="assets/imgs/about-us-pattern2.svg"/>
      <div [dir]="isRtl ? 'rtl' : 'ltr'" class="about-us-info">
        @if (isUnified) {
        <h1 class="uc-display-sm uc-medium" translate="aboutUs.header"></h1>
        } @else {
        <h2 translate="aboutUs.header"></h2>
        }
        <h3 [ngClass]="{'en-mode': !isRtl}" translate="aboutUs.aboutPlatform"></h3>
        <p class="mb-0" translate="aboutUs.platformDescription"></p>
      </div>
    </div>
  </div>
</section>
<section class="text-center">
  <img alt="" loading="lazy" src="assets/imgs/about-us-bg2.png"/>
</section>
<section>
  <div [dir]="isRtl ? 'rtl' : 'ltr'" class="container">
    <div class="about-us-details d-lg-flex align-items-start justify-content-between">
      <div class="d-flex align-items-start">
        <img alt="" loading="lazy" src="assets/imgs/about-us-vision.svg"/>
        <div>
          <h3 translate="aboutUs.vision"></h3>
          <p class="mb-0" translate="aboutUs.visionDescription"></p>
        </div>
      </div>
      <div></div>
      <div class="d-flex align-items-start">
        <img alt="" loading="lazy" src="assets/imgs/about-us-message.svg"/>
        <div>
          <h3 translate="aboutUs.message"></h3>
          <p class="mb-0" translate="aboutUs.messageDescription"></p>
        </div>
      </div>
    </div>
  </div>
</section>
<section>
  <div [dir]="isRtl ? 'rtl' : 'ltr'" class="container">
    <div class="about-us-evaluation">
      <h3 [ngClass]="{'en-mode': !isRtl}" translate="aboutUs.evaluationObjectives"></h3>
      <div class="d-lg-flex align-items-center">
        <img alt="" class="d-none d-lg-block" loading="lazy" src="assets/imgs/about-us-bg3.svg"/>
        <ul>
          <li>
            <h5 class="mb-0" translate="aboutUs.trusted"></h5>
            <p class="mb-0" translate="aboutUs.trustedDesc"></p>
          </li>
          <li>
            <h5 class="mb-0" translate="aboutUs.efficiency"></h5>
            <p class="mb-0" translate="aboutUs.efficiencyDesc"></p>
          </li>
          <li>
            <h5 class="mb-0" translate="aboutUs.flexibility"></h5>
            <p class="mb-0" translate="aboutUs.flexibilityDesc"></p>
          </li>
          <li>
            <h5 class="mb-0" translate="aboutUs.justice"></h5>
            <p class="mb-0" translate="aboutUs.justiceDesc"></p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
</ng-container>
